import { render, staticRenderFns } from "./BuroCreditoList.vue?vue&type=template&id=7b7c20ce&scoped=true&"
import script from "./BuroCreditoList.vue?vue&type=script&lang=js&"
export * from "./BuroCreditoList.vue?vue&type=script&lang=js&"
import style0 from "./BuroCreditoList.vue?vue&type=style&index=0&id=7b7c20ce&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7c20ce",
  null
  
)

export default component.exports